import { render, staticRenderFns } from "./whiteboard.menu.vue?vue&type=template&id=da4fd9f8&"
import script from "./whiteboard.menu.vue?vue&type=script&lang=js&"
export * from "./whiteboard.menu.vue?vue&type=script&lang=js&"
import style0 from "./whiteboard.menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
